import { api } from "../store/middleware/api";

const extendedApi = api.injectEndpoints({
  endpoints: (build) => ({
    promotion: build.mutation({
      query: ({ id }) => ({
        url: `/auth/use/promotion`,
        method: "POST",
        body: { promotionId: id },
      }),
    }),
    giftCard: build.mutation({
      query: ({ id }) => ({
        url: `/auth/use/gift/card`,
        method: "POST",
        body: { giftCardId: id },
      }),
    }),
    discount: build.mutation({
      query: ({ id }) => ({
        url: `/auth/use/discount`,
        method: "POST",
        body: { discountId: id },
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  usePromotionMutation,
  useGiftCardMutation,
  useDiscountMutation,
} = extendedApi;
